import $ from "jquery";
import ko from "knockout";
import activator from "flow/utils/activator";
import bind from "bind-decorator";

export interface IWorkflowStep {
    index: number;
    isLocked: KnockoutObservable<boolean>;
    isSelected: KnockoutObservable<boolean>;
    showLock: KnockoutObservable<boolean>;
    stepName?: string;
    name: string;
}

export default class Workflow {
    isVisible = ko.observable<boolean>(false);
    workflowContext = ko.observable<any>();

    steps = ko.pureComputed<IWorkflowStep[]>(() => {
        if (this.workflowContext()) {
            return this.workflowContext().steps ? this.workflowContext().steps() : [];
        } else {
            return [];
        }
    });

    links = ko.pureComputed(() => {
        if (this.workflowContext()) {
            return this.workflowContext().links ? this.workflowContext().links() : [];
        } else {
            return [];
        }
    });

    hasCustomStepNames = ko.pureComputed(() => {
        if (this.workflowContext() && this.workflowContext().hasCustomStepNames) {
            return ko.utils.unwrapObservable(this.workflowContext().hasCustomStepNames);
        }
        return false;
    });

    @bind
    onStepClicked(step: IWorkflowStep) {
        this.gotoStep(step.index, false);
    }

    gotoStep(stepIndex: number, force: boolean) {
        if (this.workflowContext() && this.workflowContext().gotoStep) {
            if (
                !force &&
                activator.canLeaveSweepWithUserFeedback(undefined, undefined, undefined, stepIndex) === false
            ) {
                return;
            }

            const step = this.steps().find(s => s.index === stepIndex);
            if (step && !step.isLocked()) {
                this.workflowContext().gotoStep(stepIndex);
            }
        }
    }

    onLinksClicked() {
        $(".lc-link-list-popover").toggle();
    }

    activate(workingContext: any) {
        this.workflowContext(workingContext);
        this.isVisible(true);
    }

    deactivate() {
        this.isVisible(false);
        this.workflowContext(null);
    }

    getHeight() {
        if (this.isVisible() === true) {
            return $("#workflow").height();
        }
        return 0;
    }
}
